const countriesReducer = (state = {}, action) => {
  switch (action.type) {
  case 'GET_COUNTRIES_WITH_CITIES':
    if (action.error) return state;
    return { countriesList: action.data };

  default:
    return state;
  }
};

export default countriesReducer;
